import {Matter} from "common/types/matter";
import {MattersFetchAction} from "../actions/fetch";
import {MatterCreateAction} from "../actions/create";
import {MatterDeleteAction} from "../actions/delete";
import {MatterRenameAction} from "../actions/rename";
import {MattersClearAction} from "../actions/clear";
import {MaybeUninitialised} from "modules/redux_types";
import UNINITIALISED from "utils/uninitialised";
import actionTypes from "../constants/action_types";

export default function mattersReducer(
  state: MaybeUninitialised<Matter[]> = UNINITIALISED,
  action:
    | MattersFetchAction
    | MattersClearAction
    | MatterDeleteAction
    | MatterRenameAction
    | MatterCreateAction,
) {
  if (action.type === actionTypes.MATTERS_FETCH.SUCCESS) {
    return (action as MattersFetchAction).payload;
  }
  if (action.type === actionTypes.MATTER_CREATE.SUCCESS) {
    if (state === UNINITIALISED) {
      return state;
    }
    return [...state, (action as MatterCreateAction).payload];
  }
  if (action.type === actionTypes.MATTER_DELETE.SUCCESS) {
    if (state === UNINITIALISED) {
      return state;
    }
    return state.filter(
      matter => matter.id !== (action as MatterDeleteAction).payload.matterId,
    );
  }
  if (action.type === actionTypes.MATTER_RENAME.SUCCESS) {
    if (state === UNINITIALISED) {
      return state;
    }
    const {id, name} = (action as MatterRenameAction).payload;
    return state.map(matter =>
      matter.id === id
        ? {
            ...matter,
            config: {
              ...matter.config,
              name,
            },
          }
        : matter,
    );
  }
  if (action.type === actionTypes.MATTERS_CLEAR.SUCCESS) {
    return UNINITIALISED;
  }

  return state;
}
